// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer[data-v-233b14a2]{width:100%;max-height:calc(90vh - 80px - 4em);overflow:hidden;display:flex;flex-direction:column}.outer .search[data-v-233b14a2]{margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./components/modal/FaceList.vue"],"names":[],"mappings":"AACA,wBACE,UAAA,CACA,kCAAA,CACA,eAAA,CACA,YAAA,CACA,qBAAA,CAEA,gCACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
